<section class="main-wrapper d-flex flex-wrap" id="main-wrapper">
  <div class="left-wrapper">
    <app-sidebar></app-sidebar>
  </div>
  <div class="right-wrapper">
    <app-header></app-header>
    <div class="content-wrapper p-8">
      <router-outlet></router-outlet>
    </div>
  </div>
</section>
